import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/invoice-actions.module.scss';
import { IInvoice } from 'src/types/invoice';
import DeleteInvoiceAction from './DeleteInvoiceAction';
import user from '../../../../../../../services/user-auth';

const InvoiceActionsColumn: React.FunctionComponent<CellProps<IInvoice>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IInvoice>) => {
    const userRole: Array<string> = user.getRoles();
    return (
        <div className={classNames(styles.actions)}>
            {userRole.map((i: string) =>
                i === 'ROLE_ADMIN' && original.status == 1 ? (
                    <>
                        <DeleteInvoiceAction data={original} />
                    </>
                ) : null,
            )}
        </div>
    );
};

export default InvoiceActionsColumn;
